import { render } from "./TrashIcon.vue?vue&type=template&id=39b69186"
const script = {}
script.render = render

export default script